import { createApi } from "@reduxjs/toolkit/query/react";
import authBaseQuery from "../../../../utils/authBaseQuery";

const AttandanceApi = createApi({
  reducerPath: "AttandanceApi",
  baseQuery: authBaseQuery,
  endpoints: (builder) => ({
    getMonthYearMergedData: builder.query({
      query: () => "get_month_year_merged_data",
      transformResponse: (response) => response?.data?.data || [],
    }),
    getWfhUser: builder.query({
      query: (id) => `get_wfh_user/${id}`,
      transformResponse: (response) => response?.data || [],
    }),

    addAttandance: builder.mutation({
      query: (addDept) => ({
        url: "add_attendance",
        method: "POST",
        body: addDept,
      }),
    }),

    getAllDepartmentsOfWFH: builder.query({
      query: () => "all_departments_of_wfh",
      transformResponse: (response) => response?.data,
    }),

    updateAttendanceStatus: builder.mutation({
      query: (body) => ({
        url: "update_attendence_status",
        method: "PUT",
        body,
      }),
    }),

    getDistinctDepartment: builder.query({
      query: ({ month, year }) => {
        const params = new URLSearchParams();
        if (month) params.append("month", month);
        if (year) params.append("year", year);

        return `get_distinct_depts?${params.toString()}`;
      },
      transformResponse: (response) => response,
    }),

    addAttandanceExcelUpload: builder.mutation({
      query: (addDept) => ({
        url: "add_attendance_with_excel",
        method: "POST",
        body: addDept,
      }),
    }),

    //END Department API's--------------------------------------------
  }),
});

export const {
  useGetMonthYearMergedDataQuery,
  useGetWfhUserQuery,
  useAddAttandanceMutation,
  useGetAllDepartmentsOfWFHQuery,
  useUpdateAttendanceStatusMutation,
  useGetDistinctDeptsMutation,
  useGetDistinctDepartmentQuery,
  useAddAttandanceExcelUploadMutation,
} = AttandanceApi;

export default AttandanceApi;
